import { UPDATE_ORGANIZATION_LOGIN } from "../../types";
import createAsyncActions from "../../../../utilities/createAsyncActions";
export const {
  updateOrganizationLogin,
  updateOrganizationLoginPending,
  updateOrganizationLoginFulfilled,
  updateOrganizationLoginRejected,
} = createAsyncActions(UPDATE_ORGANIZATION_LOGIN, "updateOrganizationLogin");



// WEBPACK FOOTER //
// ./src/features/organization/actions/updateActions/updateOrganizationLoginActions.js